import React, { ReactNode, useState } from "react"
import { useForm, NestedValue } from 'react-hook-form';
import axios from 'axios';
// fonts
import H2 from "@/fonts/h2"
import H3 from "@/fonts/h3"
import Body_1 from "@/fonts/body_1"
import Body_2 from "@/fonts/body_2"
// components
import Input from "@/components/input"
import Select from "@/components/select"
import Textarea from "@/components/Textarea"
import Card from "@/components/card"
import { Loading } from "@/components/loading"
// styles
import "@/styles/page/contact.scss"

const SvgWave: React.FC = () => (
  <svg className="editorial"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 24 150 28 "
    preserveAspectRatio="none">
    <defs>
      <path id="gentle-wave"
        d="M-160 44c30 0 
    58-18 88-18s
    58 18 88 18 
    58-18 88-18 
    58 18 88 18
    v44h-352z" />
    </defs>
    <g className="parallax4">
      <use xlinkHref="#gentle-wave" x="50" y="6" fill="#ffac4a" />
    </g>
  </svg>
)


type Props = {
  name: string,
  text: string,
  children: ReactNode
}
const FormItem: React.FC<Props> = ({ name, text, children }) => (
  <div className="form_item flex space-between">
    <label htmlFor={name} className="label flex space-between required">
      <div className="form_item-title flex">
        <Body_2>*</Body_2>
        <Body_2>{text}</Body_2>
      </div>
      {children}
    </label>
  </div>
)


type Option = {
  type: string
  company: string,
  name: string,
  email: string,
  contactType: string,
  message: string
};
const Contact: React.FC = () => {
  const [posted, setPosted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { register, handleSubmit, watch, getValues, errors } = useForm<{
    autocomplete: NestedValue<Option[]>;
    select: NestedValue<number[]>;
  }>({
    defaultValues: { autocomplete: [], select: [] },
  });

  const [selectError, setSelectError] = useState(false);
  const onSubmit = (data) => {
    setPosted(true)

    axios.post('https://us-central1-zuco-4d0b8.cloudfunctions.net/contacts', data,
      {
        xsrfHeaderName: 'X-CSRF-Token',
        withCredentials: true
      })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const onError = (errors, e) => console.log(errors, e);

  const options = [
    {
      value: "ZUCOに関するお問い合わせ",
      text: "ZUCOに関するお問い合わせ"
    },
    {
      value: "ZUCO内の問題のある投稿の報告",
      text: "ZUCO内の問題のある投稿の報告"
    },
    {
      value: "取材・掲載について",
      text: "取材・掲載について"
    },
    {
      value: "ZUCOとのコラボレーションについて",
      text: "ZUCOとのコラボレーションについて"
    },
    {
      value: "その他お問い合わせ",
      text: "その他お問い合わせ"
    },
  ]

  return (
    <div id="contact" className="page">
      <div>
        <H2>お問い合わせ</H2>
        <Card>
          {posted ?
            <>
              <div className="posted flex">
                {isLoading ? <Loading /> :
                  <div className="posted_message">
                    <H3>お問い合わせありがとうございます</H3>
                    <p>
                      内容をご確認後、担当者からご連絡させていただきます。
                      <br />
                      <br />
                      ZUCOはものづくりエンジニアにとってのオープンコミュニティとして、ナレッジ共有がより円滑にできるサービスに慣れるよう尽力いたします。
                      今後ともZUCOをよろしくお願いいたします。
                    </p>
                  </div>
                }
              </div>
            </>
            :
            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <input type="hidden" name="type" value="contact" ref={register}></input>

              <FormItem text="会社名" name="company">
                <span>
                  <Input name="company" type="text" register={register} errors={errors} ></Input>
                  <Body_1>会社もしくは学校名。個人の場合は個人と記載ください。</Body_1>
                </span>
              </FormItem>

              <FormItem text="お名前" name="name">
                <Input name="name" type="text" register={register} errors={errors}></Input>
              </FormItem>

              <FormItem text="メールアドレス" name="email">
                <Input name="email" type="email" register={register} errors={errors}></Input>
              </FormItem>

              <FormItem text="お問い合わせ種類" name="contactType">
                <Select name="contactType" options={options} register={register} errors={selectError}></Select>
              </FormItem>

              <FormItem text="お問い合わせ内容詳細" name="message">
                <Textarea name="message" register={register} errors={errors}></Textarea>
              </FormItem>

              <div className="flex" onClick={() => {
                const selectValue = getValues("contactType")
                if (selectValue === "0") setSelectError(true)
                else setSelectError(false)

                if (typeof window !== `undefined`) {
                  window.setTimeout(() => {
                    setIsLoading(false)
                    console.log(isLoading);
                  }, 2000);
                }
              }}>
                <input type="submit" className="button caribbeangreeb" value="送信する" />
              </div>
            </form>
          }
        </Card>
      </div>

      <SvgWave></SvgWave>
    </div>
  )
}

export default Contact
